
import { supabase } from '../lib/supabase';

export interface ApiKey {
  id: string;
  name: string;
  key_value: string;
  created_at: string;
  last_used_at: string | null;
  is_active: boolean;
}

function generateKey(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const segments = [8, 4, 4, 4, 12];
  return segments
    .map(len =>
      Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
    )
    .join('-');
}

export async function listApiKeys(): Promise<ApiKey[]> {
  const { data, error } = await supabase
    .from('api_keys')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) { console.error('listApiKeys error:', error); return []; }
  return (data ?? []) as ApiKey[];
}

export async function createApiKey(name: string): Promise<ApiKey | null> {
  const key_value = generateKey();
  const { data, error } = await supabase
    .from('api_keys')
    .insert({ name, key_value })
    .select()
    .maybeSingle();
  if (error) { console.error('createApiKey error:', error); return null; }
  return data as ApiKey;
}

export async function revokeApiKey(id: string): Promise<boolean> {
  const { error } = await supabase
    .from('api_keys')
    .update({ is_active: false })
    .eq('id', id);
  if (error) { console.error('revokeApiKey error:', error); return false; }
  return true;
}

export async function deleteApiKey(id: string): Promise<boolean> {
  const { error } = await supabase
    .from('api_keys')
    .delete()
    .eq('id', id);
  if (error) { console.error('deleteApiKey error:', error); return false; }
  return true;
}

export async function validateApiKeyFromDB(key: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('api_keys')
    .select('id, is_active')
    .eq('key_value', key)
    .eq('is_active', true)
    .maybeSingle();
  if (error || !data) return false;

  // Update last_used_at
  await supabase
    .from('api_keys')
    .update({ last_used_at: new Date().toISOString() })
    .eq('id', data.id);

  return true;
}
